module.exports = __webpack_public_path__ + "img/img_4.b6d5a8ba.png";